// extracted by mini-css-extract-plugin
export default {"info":"TableAgentOrganizations_info__vfQHd"};